<template>
    <span class="ext-dropdown">
        <el-dropdown @command="handleCommand" @visible-change="handleVisible">
            <span class="el-dropdown-link">
            {{ title }}<i class="el-icon--right" :class="dropClassName"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :class="{'iconed' : itemItemIconed}" v-for="item in itemList" :command="item" :disabled="item.disabled">
                    <span v-if="item.icon">
                        <i :class="getItemClass(item)" style="margin-right: 4px;"></i>{{ item.text }}
                    </span>
                    <span class="no-icon" v-else="">{{ item.text }}</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </span>
</template>
<script>
    // last modified by koqiui
    import {Utils, Jqext} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'

    let Toast = Jqext.Toast;

    export default {
        name: 'swb-ext-dropdown',
        desc: '扩展下拉菜单',
        props: {
            title: {
                type: String,
                default: ''
            },
            // 触发下拉的图标class
            dropClassName: {
                type: String,
                default: 'el-icon-arrow-down'
            },
            //
            data: null,
            //
            items: {//item:{name, text, disabled, ...}
                type: Array,
                default() {
                    return [];
                }
            },
            handler: {//{item.name, data, item}
                type: Function
            }
        },
        //
        data: function () {
            return {
                //条目是否有图标
                itemItemIconed: false,
                //
                itemList: []
            };
        },
        watch: {
            title(newVal, oldVal) {
                this.init();
            },
            data(newVal, oldVal) {
                this.init();
            },
            items(newVal, oldVal) {
                this.init();
            }
        },
        mounted() {
            this.init();
        },
        beforeDestroy() {
            this.itemList = null;
            //
            this.data = null;
            this.items = null;
            this.handler = null;
        },
        //
        methods: {
            init() {
                let itemList = Utils.merge([], this.items);
                this.itemItemIconed = itemList.any(function (item) {
                    return item.icon;
                });
                this.itemList = itemList;
            },
            getItemClass(item) {
                return item.icon;
            },
            handleCommand(item) {
                if (this.handler) {
                    this.handler.call(this.$parent, item.name, this.data, item);
                } else {
                    console.warn('点击了下拉项：' + item.name);
                }
            },
            handleVisible(visible) {
                this.$emit('dropdown-menu-visible', visible);
            }
        }
    }
</script>

<style>
    .ext-dropdown .el-dropdown {
        height: 24px;
        padding: 2px 6px;
    }

    .ext-dropdown .el-dropdown-link {
        cursor: pointer;
        color: #0c64eb;
        position: relative;
        top: 2px;
    }

    .ext-dropdown .el-icon-arrow-down {
        font-size: 12px;
    }

    .el-dropdown-menu .iconed .no-icon {
        padding-left: 17px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/ExtDropdown.vue